import React from 'react'
import PageHeader2 from '../../../componentsII/PageHeader2'

const BRSRReport = () => {
  return (
    <div>
      <PageHeader2
        title="BRSR Report ( Business Responsibility and Sustainability Report )"
        text={[
          "",
        ]}
        handleClick={() => {}}
      >
      </PageHeader2>
    </div>
  )
}

export default BRSRReport
